import type { JSX } from 'react';
import { Link } from 'react-router';
import { AuthLayout } from '../app/AuthLayout';
import { useT } from '../i18n/useT';

export const NoUnitsScreen = (): JSX.Element => {
  const t = useT();
  return (
    <AuthLayout>
      <h1 className="ow-heading">{t('No units')}</h1>
      <p>{t('You do not own any units yet.')}</p>
      <Link className="ow-link" to="/logout">
        {t('Sign out')}
      </Link>
    </AuthLayout>
  );
};
